var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TinymceEditor',{ref:"baoKaoEditorInfo",attrs:{"bizPath":_vm.$bizPath.baoKaoEditorInfo,"formType":_vm.formType},model:{value:(_vm.changeValue),callback:function ($$v) {_vm.changeValue=$$v},expression:"changeValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }